import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent {
  snackBarRef = inject<MatSnackBarRef<ToasterComponent>>(MatSnackBarRef);
  data = inject<{
    status: string;
    message: string;
  }>(MAT_SNACK_BAR_DATA);

  alertIcon = () => {
    switch (this.data.status) {
      case 'SUCCESS':
        return '../../../assets/icones/check_circle.svg';
      case 'ERROR':
        return '../../../assets/icones/cancel.svg';
      case 'WARNING':
        return '../../../assets/icones/warning_white.svg';
      case 'INFO':
        return '../../../assets/icones/info.svg';

      default:
        return '../../../assets/icones/info.svg';
    }
  };

  closeToast() {
    this.snackBarRef.dismiss();
  }
}
